import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import FooterContent from "./FooterContent";
import Button from "../Common/KnoaButton.jsx";

const GenerateButtons = ({ buttons }) => (
    buttons.map((button, index) => (
        <div key={index} className="footer-style-div">
            <Button
                disabled={button.disabled}
                type="submit"
                onClick={button.callback}
                className={"btn-fill"}
                variant={"info"}
            >
                {button.name}
            </Button>
        </div>
    ))
);

GenerateButtons.propTypes = {
    buttons: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        callback: PropTypes.func.isRequired,
        disabled: PropTypes.bool,
    })).isRequired
};

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth
        };
        this.updateDimensions = this.updateDimensions.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    updateDimensions() {
        this.setState({ width: window.innerWidth });
    }

    render() {
        const { transparent, fluid, loginpage, footerObj } = this.props;
        const isLarge = this.state.width > 992;

        const footerClass = classNames("footer", {
            "footer-transparent": transparent,
            "footer-large": !loginpage && isLarge,
            "footer-small": !loginpage && !isLarge,
            "knoa-region": !loginpage
        });

        const containerClass = classNames({
            container: !fluid,
            "container-fluid": fluid
        });

        return (
            <footer className={footerClass} tabIndex="-1" style={{zIndex:3}}>
                <div className={containerClass}>
                    {loginpage ? (
                        <FooterContent
                            useCopyrightClass
                        />
                    ) : (
                        <GenerateButtons buttons={footerObj} />
                    )}
                </div>
            </footer>
        );
    }
}

Footer.propTypes = {
    transparent: PropTypes.bool,
    fluid: PropTypes.bool,
    loginpage: PropTypes.bool,
    footerObj: PropTypes.array
};

export default Footer;